import React, {useState} from 'react';
import {classes, style} from './doppe-action-type-coupon-view.st.css';
import {Button, Icon} from '@wix/devzai-utils-react';
import IconCopy from './icons/copy.svg';
import {CommonClasses, FlexLayout} from '@wix/devzai-common-client';
import {clipboardCopy} from '@wix/devzai-utils-dom';
import {useDoppeViewerLangDictionary} from '../doppe-viewer-lang-dictionary/doppe-viewer-lang-dictionary';
import {useDoppeViewerClientServices} from '../../client/doppe-user-app/doppe-viewer-client-services';
import {BymoPageViewerMode, useBymoPageViewerContext} from '../bymo-page-viewer-context/bymo-page-viewer-context';
import {DoppeDtoAction} from '../../client-server-common/types/doppe-dto-action';
import {Values} from '@wix/devzai-utils-common';


export const CouponSourceType = {
    Action: 'Action',
    CouponAction: 'CouponAction',
    SearchLink: 'SearchLink',
    ShortLink: 'ShortLink',
} as const;

export type CouponSourceType = Values<typeof CouponSourceType>;


export const DoppeActionTypeCouponView = React.memo(function DoppeActionTypeCouponView(props: DoppeActionTypeCouponView.Props) {
    const {
        coupon,
        isIsolate = false,
        couponSourceType,
        actionId,
        onCouponCopied,

        className,
        ...htmlAttributes
    } = props;

    const [isCopied, setIsCopied] = useState(false);

    const clientServices = useDoppeViewerClientServices();
    const pageViewerContext = useBymoPageViewerContext();
    const doppeViewerLangDictionary = useDoppeViewerLangDictionary();

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {
                copied: isCopied,
                isIsolate: isIsolate
            }, className, FlexLayout.row.alignToCenter, CommonClasses.button)}
            onClick={() => {
                clipboardCopy(coupon);
                setTimeout(() => {
                    setIsCopied(false)
                }, 3000);
                setIsCopied(true);

                if (pageViewerContext.mode === BymoPageViewerMode.Live) {
                    clientServices.viewerAnalyticsClient.logEvent('uouCouponCopied', {
                        hypeUserId: pageViewerContext.doppeUserId,
                        linkId: pageViewerContext.linkId,
                        pageId: pageViewerContext.bymoPageId,
                        type: couponSourceType,
                        actionId: actionId,
                    });

                }

                onCouponCopied?.();
            }}
        >
            <div
                className={style(classes.couponText, {}, FlexLayout.fillRemainingHorizontalSpace, CommonClasses.ellipsis)}
            >
                {isCopied ? doppeViewerLangDictionary.copiedToClipboard : coupon}
            </div>
            <Icon
                className={style(classes.copyIcon, {})}
                icon={IconCopy}
            />
        </div>
    );
});

export namespace DoppeActionTypeCouponView {

    export interface Props extends Button.Props {
        coupon: string;
        isIsolate?: boolean;
        couponSourceType: CouponSourceType;
        actionId?: DoppeDtoAction.Id;
        onCouponCopied?: () => void;
    }
}
